<template>
  <div class="validate-future-slot">
    <div class="panel panel--warning">
      <div class="panel__icon panel__icon--ph_warning-fill_yellow" />
      <div class="panel__content panel-content">
        <div class="panel-content__title">
          {{ trans('validate.future.slot.warning.title') }}
        </div>
        <div class="panel-content__text">
          {{ trans('validate.future.slot.warning.content', { firstname: interlocutor.firstname }) }}
        </div>
      </div>
    </div>
    <div class="panel panel--info">
      <div class="panel__icon panel__icon--ph_lightbulb-fill_blue" />
      <div class="panel__content panel-content">
        <div class="panel-content__title">
          {{ trans('validate.future.slot.info.title') }}
        </div>
        <div class="panel-content__text">
          {{ trans('validate.future.slot.info.content') }}
          <ul>
            <!-- eslint-disable vue/no-v-html -->
            <li
              v-for="i in 3"
              :key="i"
              v-html="trans(`validate.future.slot.info.list.${i}`)"
            />
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import translation from '@elements/translation';

export default {
  mixins: [ translation ],
  props: {
    interlocutor: { type: Object, required: true },
  },
};
</script>
